import React from 'react'
import HelpStyle from './help.module.css'
import Illustrate from './component/Illustrate'
import ContactUs from './component/Contact'
function Help() {
  return (
    <div className={HelpStyle.Help_App}>
      
      <Illustrate/>
      <ContactUs/>
      <div style={{height:"20px"}}></div>
    </div>
  )
}

export default Help
